import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconFolder: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 13.4999H2C0.911736 13.5126 0.017544 12.6818 0 11.6417V2.35834V2.35835C0.0175405 1.31817 0.911728 0.487382 1.99999 0.500145H5.67999C5.91926 0.501658 6.14526 0.60546 6.29599 0.78308L8.37599 3.21479H13.976C15.067 3.18932 15.973 4.01405 15.9997 5.05689C15.9998 5.06225 15.9999 5.06762 16 5.07299V11.6417V11.6417C15.9825 12.6818 15.0883 13.5126 14 13.4999L14 13.4999Z" />
    </svg>
  </IconStyled>
);

IconFolder.defaultProps = iconDefaultProps;
IconFolder.displayName = 'IconFolder';

export default IconFolder;
